
import {createContext, useState} from 'react'

const Context = createContext()

export const FlujosAddressComplementContextProvider = ({children}) => {
 const [allFlujosAddressComplement, setAllFlujosAddressComplement] = useState([])
 const [flujosAddressComplement, setFlujosAddressComplement] = useState([]);
 const [flujoAddressComplement, setFlujoAddressComplement] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allFlujosAddressComplement, setAllFlujosAddressComplement, flujosAddressComplement, setFlujosAddressComplement, flujoAddressComplement, setFlujoAddressComplement, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context